import { c as _c } from "react/compiler-runtime";
import { Checkbox, Popover, RadioGroup } from '@systemeio/ui';
import { StatisticsFilterInterface } from 'modules/mailing/email-statistics/types/email-statistics-filter-interface';
import { BooleanStrEnum } from 'shared/enums/boolean-str-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface EmailStatisticsStatusFilterProps {
  filter: StatisticsFilterInterface;
  setFilter: React.Dispatch<React.SetStateAction<StatisticsFilterInterface>>;
}
export const EmailStatisticsStatusFilter = t0 => {
  const $ = _c(11);
  const {
    filter,
    setFilter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== filter) {
    t1 = Object.values(filter).filter(_temp);
    $[0] = filter;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const statusFilterCount = t1.length;
  let t2;
  if ($[2] !== filter || $[3] !== setFilter) {
    t2 = <div className="flex flex-col gap-3"><StatusOption filter={filter} setFilter={setFilter} slug="opened" /><StatusOption filter={filter} setFilter={setFilter} slug="clicked" /><StatusOption filter={filter} setFilter={setFilter} slug="spam" /><StatusOption filter={filter} setFilter={setFilter} slug="bounced" /></div>;
    $[2] = filter;
    $[3] = setFilter;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== statusFilterCount || $[6] !== t) {
    t3 = () => <>{t("global.filter_by")}{statusFilterCount > 0 && <span className="bg-text-primary absolute right-0 top-0 flex h-[20px] w-[20px] -translate-y-1/2 translate-x-1/2 items-center justify-center rounded-full text-xs">{statusFilterCount}</span>}</>;
    $[5] = statusFilterCount;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <Popover className="ring-brand-primary main-transition-colors bg-brand-primary text-background-secondary font-inter  hover:bg-brand-primary-hover h-[42px] !overflow-visible rounded-lg px-4 py-2.5 text-sm font-semibold ring-offset-1 focus-visible:ring-2" position="bottom" label={t2}>{t3}</Popover>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
const StatusOption = t0 => {
  const $ = _c(18);
  const {
    filter,
    setFilter,
    slug
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const t1 = !!filter[slug];
  let t2;
  if ($[0] !== setFilter || $[1] !== slug) {
    t2 = value => setFilter(prev => ({
      ...prev,
      [slug]: value ? BooleanStrEnum.true : undefined
    }));
    $[0] = setFilter;
    $[1] = slug;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = statusTitles[slug][BooleanStrEnum.true];
  let t4;
  if ($[3] !== t || $[4] !== t3) {
    t4 = t(t3);
    $[3] = t;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t4) {
    t5 = <Checkbox value={t1} onChange={t2} label={t4} />;
    $[6] = t1;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== filter || $[11] !== setFilter || $[12] !== slug || $[13] !== t) {
    t6 = !!filter[slug] && <RadioGroup optionsWrapperClassName="pl-5 flex-col !gap-3 !items-start" options={[{
      id: BooleanStrEnum.true,
      caption: t(statusTitles[slug][BooleanStrEnum.true])
    }, {
      id: BooleanStrEnum.false,
      caption: t(statusTitles[slug][BooleanStrEnum.false])
    }]} selected={filter[slug]} onChange={value_0 => {
      setFilter(prev_0 => ({
        ...prev_0,
        [slug]: value_0
      }));
    }} />;
    $[10] = filter;
    $[11] = setFilter;
    $[12] = slug;
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
const statusTitles: Record<keyof Omit<StatisticsFilterInterface, 'contacts'>, Record<BooleanStrEnum, string>> = {
  opened: {
    [BooleanStrEnum.true]: 'dashboard.email_statistics.table.headers.opened',
    [BooleanStrEnum.false]: 'dashboard.email_statistics.table.headers.not_opened'
  },
  spam: {
    [BooleanStrEnum.true]: 'dashboard.email_statistics.table.headers.reported_as_spam',
    [BooleanStrEnum.false]: 'dashboard.email_statistics.table.headers.not_reported_as_spam'
  },
  bounced: {
    [BooleanStrEnum.true]: 'dashboard.email_statistics.table.headers.bounced',
    [BooleanStrEnum.false]: 'dashboard.email_statistics.table.headers.not_bounced'
  },
  clicked: {
    [BooleanStrEnum.true]: 'dashboard.email_statistics.table.headers.clicked',
    [BooleanStrEnum.false]: 'dashboard.email_statistics.table.headers.not_clicked'
  }
};
function _temp(value) {
  return Object.values(BooleanStrEnum).includes(value);
}